import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Col, Input, Button, Form, Drawer, Radio, DatePicker } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { putApi } from 'redux/sagas/putApiSaga';
import { API_STATUS, DATE_FORMAT, GENDER } from 'constants/app-constants';
import { SERVER_IP } from 'assets/Config';
import { postApi } from 'redux/sagas/postApiDataSaga';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import FileUpload from 'components/file-upload/file-upload';
import { useI18n } from 'hooks/useI18n';

const AddCoach = ({ coachAddModal, width = '40%', editCoach, setCoachAddModal, refreshList, handleClose }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state.globalRedux);
	const dispatch = useDispatch();
	const [coachImage, setCoachImage] = useState([]);
	const branchId = globalRedux?.selectedBranch?.id;

	useEffect(() => {
		setCoachImage([]);
		if (editCoach) {
			const coachImg = JSON.parse(JSON.stringify(editCoach));

			if (coachImg.image && coachImg.image.length && coachImg?.image[0]?.url) {
				coachImg.image[0] = typeof coachImg?.image[0] === 'string' ? JSON.parse(coachImg?.image[0]) : coachImg?.image[0];
				coachImg.image[0].url = String(coachImg?.image[0]?.url).includes(SERVER_IP)
					? coachImg?.image[0]?.url
					: SERVER_IP + coachImg?.image[0]?.url;
			} else {
				coachImg.image = [];
			}
			form.setFieldsValue({
				// type: editCoach?.type || 'Contact',
				coachName: editCoach?.coachName || '',
				age: editCoach?.age || '',
				email: editCoach?.email || '',
				password: editCoach?.password || '',
				mobile: editCoach?.mobile || '',
				address: editCoach?.address || '',
				gender: editCoach?.gender || '',
				aadhaarNo: editCoach?.aadhaarNo || '',
				joiningDate: moment(editCoach?.joiningDate) || '',
				image: coachImg.image || [],
			});
			if (coachImg?.image?.length) {
				setCoachImage(coachImg?.image);
			}
		} else {
			form?.resetFields();
		}
	}, [editCoach, form]);

	const handleSubmit = (values) => {
		const coachPic = {
			uid: coachImage[0]?.uid,
			url: coachImage[0]?.url?.replace(SERVER_IP, '') || '',
			name: coachImage[0]?.name,
			thumbUrl: coachImage[0]?.thumbUrl,
		};

		coachImage[0] = coachPic;
		let data = {
			coachName: values?.coachName || '',
			age: values?.age || '',
			email: values?.email || '',
			mobile: values?.mobile || '',
			address: values?.address || '',
			gender: values?.gender || '',
			joiningDate: values?.joiningDate || '',
			aadhaarNo: values?.aadhaarNo || '',
			branchId,
			image: coachImage,
			role: 'staff',
			...(!editCoach && { password: values?.password || '' }),
		};

		if (!editCoach) {
			dispatch(postApi(data, 'ADD_COACH'));
		} else {
			let url = `${SERVER_IP}api/coaches/${editCoach.id}`;
			dispatch(putApi(data, 'EDIT_COACH', url));
		}
	};

	useEffect(() => {
		if (globalRedux.apiStatus.ADD_COACH === 'SUCCESS' || globalRedux.apiStatus.EDIT_COACH === 'SUCCESS') {
			dispatch(resetApiStatus(editCoach ? 'EDIT_COACH' : 'ADD_COACH'));
			refreshList?.();
			handleClose?.();
			form?.resetFields();
		}
	}, [globalRedux.apiStatus, editCoach, setCoachAddModal, dispatch, refreshList, handleClose, form]);

	const { t } = useI18n();

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const loading = globalRedux.apiStatus.ADD_COACH === API_STATUS.PENDING || globalRedux.apiStatus.EDIT_COACH === API_STATUS.PENDING;

	return (
		<Drawer
			placement="right"
			title={editCoach ? t('coaches.edit_coach') : t('coaches.create_coach')}
			width={width || '40%'}
			visible={coachAddModal}
			closable
			onClose={() => setCoachAddModal(false)}
			destroyOnClose={true}>
			<Row>
				<Col span={24}>
					{/* <Row style={{ backgroundColor: '#fff', padding: '10px 0px' }}>
						<Col>
							<h6 style={{ marginBottom: '0px' }}>{editCoach ? 'Edit' : 'New'} Coach</h6>
						</Col>
					</Row>
					<Divider /> */}
					<Row style={{ marginTop: 20 }}>
						<Form
							name="add-coach"
							className="required_in_right"
							style={{ width: '100%' }}
							colon={true}
							labelAlign="left"
							form={form}
							onFinish={handleSubmit}
							initialValues={{}}
							{...layer1FormCol}>
							<Form.Item
								label={t('coaches.columns.coach_name')}
								name="coachName"
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}>
								<Input placeholder={t('coaches.columns.coach_name')} />
							</Form.Item>
							<Form.Item
								label={t('customers.age')}
								name="age"
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}>
								<Input placeholder={t('customers.age')} />
							</Form.Item>
							<Form.Item
								label={t('customers.gender')}
								name="gender"
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}>
								<Radio.Group options={GENDER} optionType="button" buttonStyle="solid" />
							</Form.Item>
							<Form.Item
								label={t('customers.mobile')}
								name="mobile"
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}>
								<Input maxLength={10} placeholder={t('customers.mobile')} />
							</Form.Item>
							<Form.Item
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}
								label={t('customers.email')}
								name="email">
								<Input placeholder={t('customers.email')} />
							</Form.Item>
							{!!!editCoach && (
								<Form.Item
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}
									label={t('forms.password')}
									name="password">
									<Input.Password
										placeholder={t('forms.password')}
									/>
								</Form.Item>
							)}
							<Form.Item
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}
								label={t('customers.aadhaar')}
								name="aadhaarNo">
								<Input placeholder={t('customers.aadhaar')} />
							</Form.Item>
							<Form.Item
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}
								label={t('customers.joining_date')}
								name="joiningDate">
								<DatePicker style={{ width: '100%' }} format={DATE_FORMAT.DD_MM_YYYY} />
							</Form.Item>
							<Form.Item
								label={t('coaches.columns.address')}
								name="address"
								rules={[
									{
										required: false,
										message: t('forms.this_field_required'),
									},
								]}>
								<Input.TextArea placeholder={t('coaches.columns.address')} />
							</Form.Item>
							<FileUpload
								action={'/'}
								afterUpload={() => {}}
								max={1}
								fileList={form.getFieldValue('image')}
								setFileList={setCoachImage}
							/>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}>
								<Row className="space-between" style={{ paddingTop: 20, width: '100%', margin: 0 }}>
									<Button danger style={{ width: '49%' }} onClick={() => setCoachAddModal(false)}>
										{t('forms.cancel')}
									</Button>
									<Button loading={loading} style={{ width: '49%' }} type="primary" htmlType="submit">
										{editCoach ? t('common.update') : t('common.save')}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Row>
				</Col>
			</Row>
		</Drawer>
	);
};

export default AddCoach;
